import { render, staticRenderFns } from "./HomeSocialMedia.vue?vue&type=template&id=388fea30"
import script from "./HomeSocialMedia.vue?vue&type=script&lang=js"
export * from "./HomeSocialMedia.vue?vue&type=script&lang=js"
import "./HomeSocialMedia.vue?vue&type=style&index=0&id=388fea30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports